// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2rReC","inputWrap":"CustomTip_inputWrap__1l-pX"};